import { createRoot, Root } from 'react-dom/client';
import { renderApp } from 'src/index';
import {
  WebSdkInitOptions,
  WebSdkEventHandlers,
  webSdkEventHandlersInitialValues,
} from 'src/webSdk/models/webSdk';
import { StyleSheetManager } from 'styled-components';

class WebSdk {
  private root: Root | null = null;
  private rootContainer: HTMLElement | null = null;

  public constructor(
    private initOptions: WebSdkInitOptions,
    private eventHandlers: WebSdkEventHandlers
  ) {}

  /**
   * Launches the Web SDK using the provided container id as an application root.
   * @param containerId
   */
  public async launch(containerId: string): Promise<WebSdk> {
    this.rootContainer = document.getElementById(containerId);

    if (this.rootContainer) {
      // Render SDK in shadowDOM
      const shadowHost = document.createElement('div');
      shadowHost.setAttribute('id', 'shadow-host');

      this.rootContainer.appendChild(shadowHost);
      shadowHost.attachShadow({ mode: 'open' });

      const body = document.createElement('body');
      shadowHost.shadowRoot?.appendChild(body);

      const section = document.createElement('section');
      body.appendChild(section);

      document
        .querySelectorAll('style[data-sdkstyle=true]')
        .forEach((style) => {
          body.appendChild(style);
          style.innerHTML = style.innerHTML.replace(/:root/g, ':host');
        });

      this.root = createRoot(section);
      this.root.render(
        <StyleSheetManager target={body}>
          {renderApp(this.initOptions, this.eventHandlers)}
        </StyleSheetManager>
      );
    } else {
      throw Error(`No element with the id of ${containerId} found.`);
    }

    return this;
  }

  /**
   * Cleans up the Web SDK process and removes the application container from DOM.
   */
  public destroy() {
    // this.root?.unmount();
    // this.rootContainer?.remove();
  }
}

export class WebSdkBuilder {
  private eventHandlers: WebSdkEventHandlers = webSdkEventHandlersInitialValues;

  constructor(private initOptions: WebSdkInitOptions) {}

  on<T extends keyof WebSdkEventHandlers>(
    eventType: T,
    handler: WebSdkEventHandlers[T]
  ): WebSdkBuilder {
    this.eventHandlers[eventType] = handler;
    return this;
  }

  build(): WebSdk {
    return new WebSdk(this.initOptions, this.eventHandlers);
  }
}
